import { useDmsWithLegislativeBodiesConnection } from '../useDmsWithLegislativeBodiesConnection';

type Result = ModelHookResult<{
	showDMSection: boolean;
}>;

export function useDecisionMakerSection(): Result {
	const {
		data: { totalCount: dmsAndLBsTotalCount },
	} = useDmsWithLegislativeBodiesConnection();

	return {
		data: {
			showDMSection: dmsAndLBsTotalCount > 0,
		},
	};
}
